import script from "./studentList.vue?vue&type=script&setup=true&lang=js"
export * from "./studentList.vue?vue&type=script&setup=true&lang=js"

import "./studentList.vue?vue&type=style&index=0&id=f2bc5f82&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2bc5f82"]])

export default __exports__